import { XIcon } from "@phosphor-icons/react/dist/csr/X";
import { useCallback, useEffect, useRef } from "react";
import { MILESTONES } from "@hicya/habits-shared/data";

import styles from "./milestone-toast.module.scss";

interface MilestoneToastProps {
  milestoneId: string;
  onDismiss: (milestoneId: string) => void;
}

export function MilestoneToast({ milestoneId, onDismiss }: MilestoneToastProps) {
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const milestone = MILESTONES.find((m) => m.id === milestoneId);

  const handleDismiss = useCallback(() => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
    onDismiss(milestoneId);
  }, [milestoneId, onDismiss]);

  useEffect(() => {
    timerRef.current = setTimeout(handleDismiss, 5000);
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [handleDismiss]);

  if (!milestone) return null;

  return (
    <div className={styles.toast} data-testid="milestone-toast" role="status">
      <div className={styles.body}>
        <span className={styles.title}>{milestone.title}</span>
        <span className={styles.description}>{milestone.description}</span>
      </div>
      <button type="button" className={styles.dismiss} onClick={handleDismiss} aria-label="Dismiss">
        <XIcon size={20} aria-hidden="true" />
      </button>
    </div>
  );
}
